module.exports = __webpack_public_path__ + "static/media/training.f06da3cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/training.jpg
// module id = 5827
// module chunks = 0